import { unsafeCSS } from 'lit';
export const SEND_TO_SHADOW_REALM = unsafeCSS`
position: fixed !important;
top: -999px !important;
left: -999px !important;
visibility: hidden !important;
pointer-events: none !important;
`;